import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../datasource/api";
import {
  EmailOtpDataType,
  forgotPasswordDispatchType,
} from "../../modals/IforgotPasswordCard";
import { resetPasswordDataType } from "../../modals/IresetPasswordCard";
import routesName from "../../constants/routesName";
import axios from "axios";

export const ec = createAsyncThunk(
  "profileemailCheck",
  async (data: forgotPasswordDispatchType, { rejectWithValue }) => {
    try {
      const response = await API.post("Profile/forgotpasswordadmincheck", data);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);

export const profilforgotPassword = createAsyncThunk(
  "profilforgotPassword",
  async (data: forgotPasswordDispatchType, { rejectWithValue }) => {
    try {
      const response = await API.post("Profile/forgotpassword", data);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);

export const profilverifyOtp = createAsyncThunk(
  "profilverifyOtp",
  async (data: EmailOtpDataType, { rejectWithValue }) => {
    try {
      const response = await API.post("Profile/verifyotp", data);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);

// export const profilresetPassword = createAsyncThunk(
//   "profileresetPassword",
//   async (data: any, { rejectWithValue }) => {
//     try {
//       const response = await API.post("Profile/passwordreset", data);
//       return response.data;
//     } catch (error : any) {
//       if (error?.response?.status === 500) {
//         window.location.href = routesName.errorPage;
//       }
//       return rejectWithValue(error);
//     }
//   }
// );
export const profilresetPassword = createAsyncThunk(
  "profileresetPassword",
  async (data: any, { rejectWithValue }) => {
    try {
      console.log(data, 374747)
      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';
      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
        const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
        return encrypted.toString();
      };

      const Email = data.email;
      const NewPassword = encryptString(data.password);
      const url = process.env.REACT_APP_MA_RESET_PASSWORD_URL || '';
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
      };

      const maResponse = await axios.post(url, { Email, NewPassword }, { headers });

      if (maResponse) {
        const response = await API.post("Profile/passwordreset", data);
        return response.data;
      }
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);
